import { render, staticRenderFns } from "./BenefitAnalysis.vue?vue&type=template&id=22b1dc12&scoped=true"
import script from "./BenefitAnalysis.vue?vue&type=script&lang=js"
export * from "./BenefitAnalysis.vue?vue&type=script&lang=js"
import style0 from "./BenefitAnalysis.vue?vue&type=style&index=0&id=22b1dc12&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b1dc12",
  null
  
)

export default component.exports